export default __webpack_public_path__ + "static/media/recurly-logo-toolbox.e7103494.svg";